import { ErrorMessage as BaseErrorMessage, ErrorMessageProps } from 'formik'
import React, { FC } from 'react'

const ErrorMessage: FC<ErrorMessageProps> = (props) => (
  <BaseErrorMessage {...props}>{(msg) => <p className="help is-danger">{msg}</p>}</BaseErrorMessage>
)

export default ErrorMessage
